<template>
<b-container class="px-0">
    <b-row class="justify-content-md-center">
        <b-col cols=12>
            <b-card no-body tag="h1" class="border-0 pt-3 pb-3 bg-transparent">{{titlu}}
            </b-card>
            <div class="text-center" flex>
                <b-button variant="primary" class="px-4 my-2 btn-index-card" @click="closeChat()" v-if="state == 'deschis'">Ascunde</b-button>
                <b-button variant="primary" class="px-4 my-2 btn-index-card" @click="openChat()" v-if="state == 'inchis'">Afișează</b-button>
            </div>
        </b-col>
    </b-row>

    <b-row class="justify-content-md-center">

        <b-col cols=12 class="py-3">
            <b-card class="shadow px-1 pt-1 pb-4 rounded bg-transparent">
                <b-card-text v-html="continut"></b-card-text>
            </b-card>

        </b-col>
    </b-row>

</b-container>
</template>

<script>
//import chat from '@/assets/chat.js';

export default {
    mounted() {

    },
    data() {
        return {
            titlu: '',
            continut: '',
            state: 'deschis'
        };
    },
    methods: {
        getInfo() {
            fetch('https://app.bibliotecaarad.ro/backend/api/chat')
                .then(response => response.json())
                .then(data => {
                    this.titlu = data[0]['titlu'];
                    this.continut = data[0]['continut'];
                });
        },
        closeChat() {
            this.state = 'inchis';
            localStorage.setItem("state", JSON.stringify(this.state));

        },
        openChat() {
            this.state = 'deschis';
            localStorage.setItem("state", JSON.stringify(this.state));

        },
        stateChat() {
            if (this.state == 'deschis') {
                (function (w, d, s, u) {
                    w.RocketChat = function (c) {
                        w.RocketChat._.push(c)
                    };
                    w.RocketChat._ = [];
                    w.RocketChat.url = u;
                    var h = d.getElementsByTagName(s)[0],
                        j = d.createElement(s);
                    j.async = true;
                    j.src = 'https://chat.bibliotecaarad.ro/livechat/rocketchat-livechat.min.js?_=201903270000';
                    h.parentNode.insertBefore(j, h);
                })(window, document, 'script', 'https://chat.bibliotecaarad.ro/livechat');
            }

        },
    },
    created() {
        var stare = JSON.parse(localStorage.getItem("state"));
        if (stare == 'deschis') {
            this.state = JSON.parse(localStorage.getItem("state"));
        }

        if (stare == null) {
         this.state = "deschis";
         localStorage.setItem("state", JSON.stringify(this.state));
        }

            this.getInfo(),
            this.stateChat()
        },
        watch: {
            state: function () {

                if (this.state == 'deschis') {
                    this.stateChat();
                }
                if (this.state == 'inchis') {
                    document.querySelectorAll('.rocketchat-widget').forEach(function (a) {
                        a.remove()
                    })
                }
            }
        }
    }
</script>

<style></style>
